import { Component } from 'react';
import moment from 'moment';
import { createCompany } from '../../../../../../../../insfrastructure/services/companies';
import { formatDateOnly, normalizeDateOnlyFromApi } from '../../../../../../../../insfrastructure/utils/date-formatter';
import ResponseModal from '../../../../../../../components/response-modal';
import { withRouter } from '../../../../../../../../insfrastructure/utils/with-router-component';
import { StaticValues } from '../../../../../../../../insfrastructure/services/static_values'
import companyImg from '../../../../../../../../assets/images/company.png';
import { TermsOfUseModal } from '../../../../../../../components/terms-of-use-modal';
import { logger } from '../../../../../../../../insfrastructure/services/analytics';
import './styles.sass'

class Resume extends Component<{ company_data: Record<string, any>, about_company: Record<string, any>, company_user_data: Record<string, any>, navigate: any, onBack?: () => void }> {
  state: Record<string, any> = {
    responseData: null,
    loading: false,
    renderTermsOfUse: false,
    genderOptions: [],
  }

  componentDidMount() {
    this.getStaticValues();
  }

  getStaticValues = async () => {
    try {  
      setTimeout(() => {
        const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;
        const genderOptions = Object.keys(staticValues.gender).map((key: any) => ({ value: key, label: staticValues.gender[key] }));
        this.setState({ genderOptions });
      }, 1000);
    } catch (error) {
      logger.error('Error loading static values', error as Error);
    }
  }

  onSubmit = async () => {
    if (this.state.loading) return;

    try {
      this.setState({ loading: true });

      let data = {
        ...this.props.company_data,
        ...this.props.about_company,
        ...this.props.company_user_data
      };

      data.cpf = data.cpf.replace(/[-.]/g, '');
      data.cnpj = data.cnpj.replace(/[./-]/g, '');
      // DateOfBirthField retorna string DD/MM/YYYY; só envia se virar YYYY-MM-DD válido
      const formattedDateOfBirth = data.date_of_birth ? formatDateOnly(data.date_of_birth) : undefined;
      data.date_of_birth = typeof formattedDateOfBirth === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(formattedDateOfBirth)
        ? formattedDateOfBirth
        : undefined;
      
      // Ensure em_unit is a number if it exists
      if (data.em_unit) {
        data.em_unit = parseInt(data.em_unit);
      }

      if (data.ie_free) {
        delete data.ie;
      }

      delete data.ie_free;

      await createCompany(data as any);
    
      this.props.navigate('/sign-up/company/confirmation/request', { state: { email: this.props.company_user_data.manager_email } });
    } catch (error: any) {
      let errors: string[] = [];
      const status = error?.response?.status;
      const responsePayload = error?.response?.data;

      // Log seguro para Sentry/Firebase (mascara PII automaticamente)
      logger.error('Company signup API error', error, {
        context: 'company_signup',
        status,
        response: responsePayload
      });

      // Verificação segura: só acessa error.response.data se existir
      if (responsePayload) {
        const errorData = responsePayload;

        if (errorData['user.email'] || errorData['manager.email']) {
          errors.push('Email já cadastrado');
        }

        if (errorData['manager.cpf']) {
          errors.push('CPF já cadastrado');
        }

        if (errorData['company.ie'] || errorData['ie']) {
          const ieError = errorData['company.ie'] || errorData['ie'];
          const ieText = Array.isArray(ieError) ? ieError[0] : ieError;
          errors.push(`IE: ${ieText}`);
        }
        
        if (errorData['company.cnpj'] || errorData['cnpj']) {
          errors.push('CNPJ já cadastrado');
        }

        // Não exibir mensagens não tratadas vindas do backend
      }

      // Se não há erros específicos da API, mostrar mensagem genérica
      if (errors.length === 0) {
        errors.push('Erro ao processar cadastro. Tente novamente.');
      }

      let responseData = {
        type: 'error',
        title: 'Erro ao cadastrar',
        text: () => <>
          { errors.map(error => <p>{error}</p>) }
        </>
      };

      this.setState({ loading: false, responseData });
    };
  }

  render() {
    return (
      <div className='resume'>
        <div className='form-container'>
          <div className='columns'>
            <div className='column'>
              <div className='data-block'>
                <h4>Dados Empresa</h4>
                <div>
                  <p>Nome de Empresa: <b>{this.props.company_data.fantasy_name}</b></p>
                  <p>CNPJ: <b>{this.props.company_data.cnpj}</b></p>
                  <p>IE: <b>{this.props.company_data.ie_free ? 'Isento' : (this.props.company_data.ie || '-')}</b></p>
                  <p>Telefone: <b>{this.props.company_data.phone}</b></p>
                  <p>Endereço: <b>{(() => {
                    const parts = [];
                    if (this.props.company_data.street) parts.push(this.props.company_data.street);
                    if (this.props.company_data.address_number) parts.push(this.props.company_data.address_number);
                    if (this.props.company_data.address_district) parts.push(this.props.company_data.address_district);
                    return parts.length > 0 ? parts.join(', ') : '-';
                  })()}</b></p>
                  <p>Cidade: <b>{this.props.company_data.city}</b></p>
                  <p>Estado: <b>{this.props.company_data.uf}</b></p>
                </div>
              </div>
              <div className='text-block'>
                <h4>Sobre a Empresa</h4>
                <p>{this.props.about_company.description}</p>
              </div>
            </div>
            <div className='column'>
              <div className='data-block'>
                <h4>Dados do Responsável</h4>
                <div>
                  <p>Nome Completo: <b>{this.props.company_user_data.full_name}</b></p>
                  <p>CPF: <b>{this.props.company_user_data.cpf}</b></p>
                  {/* <p>Celular: <b>{this.props.company_user_data.phone}</b></p> */}
                  <p>E-mail: <b>{this.props.company_user_data.manager_email}</b></p>
                  <p>Data de nascimento: <b>{(() => {
                    const normalized = normalizeDateOnlyFromApi(this.props.company_user_data.date_of_birth);
                    return normalized ? moment(normalized, 'YYYY-MM-DD').format('DD/MM/YYYY') : '-';
                  })()}</b></p>
                  <p>Gênero: <b>{this.state.genderOptions[this.props.company_user_data.gender] || '-'}</b></p>
                  {/* <p>Estado: <b>{this.props.company_user_data.uf}</b></p> */}
                  {/* <p>Cidade: <b>{this.props.company_user_data.city}</b></p> */}
                </div>
              </div>
              <div className='text-block'>
                <h4>Por que trabalhar com a gente?</h4>
                <p>{this.props.about_company.motivation}</p>
              </div>
            </div>
            <div className='column'>
              <img src={companyImg} alt='company' />
            </div>
          </div>
          <div className='submit-block'>
            <div>
              <h4>Aviso Importante</h4>
              <p>Ao confirmar esta ação, você declara e concorda que assume total responsabilidade pela precisão e veracidade das informações fornecidas em nome da empresa.
                Além disso, você se compromete a responder legalmente por qualquer consequência que possa advir de informações incorretas ou imprecisas, sendo a principal responsável pela credibilidade dos dados apresentados.
                Certifique-se de revisar todas as informações com atenção antes de prosseguir. A sua confirmação implica na aceitação dos termos acima e na responsabilidade legal associada.</p>
              <a 
                href='/terms-of-use' 
                target='_blank' 
                rel='noopener noreferrer'
                style={{ color: '#FFD700', textDecoration: 'underline', fontWeight: '600', cursor: 'pointer' }}
              >
                Termos de Uso
              </a>
            </div>
            <div style={{ width: '50%', display: 'flex', alignItems: 'center' }}>
              <div className='columns' style={{ borderBottom: 'none', borderTop: 'none', width: '100%', alignItems: 'center' }}>
                {this.props.onBack ? (
                  <>
                    <div className='column' style={{ borderRight: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '18px' }}>
                      <button className='secondary submit' onClick={this.props.onBack} style={{ width: '100%', margin: 0, border: '1px solid #105099' }}>Voltar</button>
                    </div>
                    <div className='column' style={{ borderRight: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '18px' }}>
                      <button className='primary submit' disabled={this.state.loading} onClick={this.onSubmit} style={{ width: '100%', margin: 0 }}>
                        { !this.state.loading ? 'Confirmar' : 'Enviando...' }
                      </button>
                    </div>
                  </>
                ) : (
                  <div className='column' style={{ borderRight: 'none', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '18px' }}>
                    <button className='primary submit' disabled={this.state.loading} onClick={this.onSubmit} style={{ width: '100%', margin: 0 }}>
                      { !this.state.loading ? 'Confirmar' : 'Enviando...' }
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <ResponseModal
        render={this.state.responseData}
        type={this.state.responseData?.type}
        title={this.state.responseData?.title}
        text={this.state.responseData?.text}
        onClose={() => this.setState({ responseData: null })} />
        <TermsOfUseModal
        render={this.state.renderTermsOfUse}
        onClose={() => this.setState({ renderTermsOfUse: false })} />
      </div>
    )
  }
}

export const ResumeWithRouter = withRouter(Resume);

